import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";

export function ProtectedRoute({ children }) {
  const { authToken } = useAuth();
  const location = useLocation();

  if (!authToken) {
    // Encode the full attempted path+search so nothing is lost.
    // LoginPage already reads qParams.get("next") — no changes needed there.
    const next = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/login?next=${next}`} replace />;
  }

  // Layout-route: no children prop → render nested routes via <Outlet>
  return children ?? <Outlet />;
}
